import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ReviewWorkspaceCommentBubble extends PureComponent {
    static propTypes = {
        assetReviewItemsForSectionItem: PropTypes.arrayOf(PropTypes.object),
        toggleCommentPane: PropTypes.func
    };

    _makeClassName = () => {
        const { assetReviewItemsForSectionItem = [] } = this.props;
        let commentBubbleColor = '';

        if (assetReviewItemsForSectionItem.length) {
            commentBubbleColor = 'teal';
        }

        for (let i = 0, leng = assetReviewItemsForSectionItem.length; i < leng; i += 1) {
            if (assetReviewItemsForSectionItem[i].status === 'OPEN') {
                commentBubbleColor = 'pink';
                break;
            }
        }

        return `workspace-comment-bubble hidden-xs fas fa-comment ${commentBubbleColor}`;
    };

    render() {
        const { toggleCommentPane } = this.props;
        return <span className={this._makeClassName()} onClick={toggleCommentPane} />;
    }
}
